module.exports = __webpack_public_path__ + "static/a13-5db618587412d2dedbb78e347c8c2a41.jpg";